import { render, staticRenderFns } from "./cus-payset-form.vue?vue&type=template&id=fa80ea62&scoped=true&"
import script from "./cus-payset-form.vue?vue&type=script&lang=js&"
export * from "./cus-payset-form.vue?vue&type=script&lang=js&"
import style0 from "./cus-payset-form.vue?vue&type=style&index=0&id=fa80ea62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa80ea62",
  null
  
)

export default component.exports